export enum SessionStorageKeys {
	LastAutoLogout = 'lastAutoLogout',
	SupportBotAnimationShown = 'supportAnimation',
	UserJourney = 'userJourney',
	VisitReported = 'visitReported'
}
